(function () {
  const CALLBACK_PARAM = "login_popup";
  const CALLBACK_VALUE = "done";
  const POPUP_NAME = "shopify-customer-login";
  const POPUP_WIDTH = 540;
  const POPUP_HEIGHT = 760;

  function getCleanCurrentUrl() {
    const url = new URL(window.location.href);
    url.searchParams.delete(CALLBACK_PARAM);
    return url;
  }

  function getReturnToPath() {
    const url = getCleanCurrentUrl();
    url.searchParams.set(CALLBACK_PARAM, CALLBACK_VALUE);
    return `${url.pathname}${url.search}${url.hash}`;
  }

  function getPopupFeatures() {
    const left = Math.max(0, Math.round(window.screenX + (window.outerWidth - POPUP_WIDTH) / 2));
    const top = Math.max(0, Math.round(window.screenY + (window.outerHeight - POPUP_HEIGHT) / 2));

    return [
      "popup=yes",
      `width=${POPUP_WIDTH}`,
      `height=${POPUP_HEIGHT}`,
      `left=${left}`,
      `top=${top}`,
      "resizable=yes",
      "scrollbars=yes"
    ].join(",");
  }

  function buildLoginUrl(rawHref) {
    const source = new URL(rawHref, window.location.origin);
    const loginUrl = new URL("/customer_authentication/login", window.location.origin);

    source.searchParams.forEach((value, key) => {
      if (key !== "return_to") {
        loginUrl.searchParams.set(key, value);
      }
    });

    loginUrl.searchParams.set("return_to", getReturnToPath());
    return loginUrl.toString();
  }

  function fallbackNavigate(url) {
    window.location.assign(url);
  }

  function openPopup(url) {
    const popup = window.open(url, POPUP_NAME, getPopupFeatures());
    if (popup) {
      try {
        popup.focus();
      } catch (_error) {}
      return true;
    }
    return false;
  }

  function handlePopupCallback() {
    const url = new URL(window.location.href);
    if (url.searchParams.get(CALLBACK_PARAM) !== CALLBACK_VALUE) return;

    const cleanUrl = getCleanCurrentUrl();
    const cleanHref = `${cleanUrl.pathname}${cleanUrl.search}${cleanUrl.hash}`;

    if (window.opener && !window.opener.closed) {
      try {
        window.opener.location.reload();
      } catch (_error) {}

      try {
        window.history.replaceState({}, "", cleanHref);
      } catch (_error) {}

      try {
        window.close();
      } catch (_error) {}

      window.setTimeout(() => {
        try {
          window.close();
        } catch (_error) {}
      }, 120);

      return;
    }

    try {
      window.history.replaceState({}, "", cleanHref);
    } catch (_error) {}
  }

  function bindLoginLink(node) {
    if (!(node instanceof HTMLAnchorElement)) return;
    if (node.dataset.loginBreakoutBound === "true") return;

    node.dataset.loginBreakoutBound = "true";

    node.addEventListener("click", (event) => {
      event.preventDefault();

      const loginUrl = buildLoginUrl(node.href);
      const opened = openPopup(loginUrl);

      if (!opened) {
        fallbackNavigate(loginUrl);
      }
    });
  }

  function boot(scope) {
    handlePopupCallback();

    const root = scope instanceof Element || scope instanceof Document ? scope : document;
    root.querySelectorAll?.("[data-storefront-login-link]").forEach(bindLoginLink);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => boot(document));
  } else {
    boot(document);
  }
})();
